import React, { useEffect } from 'react';
import { CheckCircle, Phone, Mail, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="min-h-screen flex items-center justify-center px-4 pt-32 pb-16">
        <div className="max-w-2xl w-full">
          {/* Success Icon */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-emerald-100 rounded-full mb-6">
              <CheckCircle className="h-12 w-12 text-emerald-600" />
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Thank You!
            </h1>
            
            <p className="text-xl text-slate-600 mb-2">
              Your request has been successfully submitted.
            </p>
            
            <p className="text-lg text-slate-500">
              We'll contact you within 24 hours to discuss your garage cleaning needs.
            </p>
          </div>

          {/* What Happens Next */}
          <div className="bg-gradient-to-br from-emerald-50 to-blue-50 p-8 rounded-2xl border-2 border-emerald-100 mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-2">
              <span className="text-emerald-600">📋</span> What Happens Next?
            </h2>
            
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">We Review Your Request</h3>
                  <p className="text-slate-600">Our team will carefully review your information and prepare a personalized quote.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">We'll Contact You</h3>
                  <p className="text-slate-600">Expect a call or email within 24 hours to discuss your project details.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold">
                  3
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">Schedule Your Service</h3>
                  <p className="text-slate-600">We'll work with your schedule to find the perfect time for your garage transformation.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <div className="flex items-center gap-4 p-4 bg-white rounded-lg border-2 border-slate-200 hover:border-emerald-500 transition-colors">
              <div className="bg-emerald-100 p-3 rounded-full">
                <Phone className="h-6 w-6 text-emerald-600" />
              </div>
              <div>
                <p className="text-sm text-slate-600">Need immediate help?</p>
                <a href="tel:386-283-0286" className="text-lg font-bold text-slate-900 hover:text-emerald-600">
                  386-283-0286
                </a>
              </div>
            </div>
            
            <div className="flex items-center gap-4 p-4 bg-white rounded-lg border-2 border-slate-200 hover:border-emerald-500 transition-colors">
              <div className="bg-emerald-100 p-3 rounded-full">
                <Mail className="h-6 w-6 text-emerald-600" />
              </div>
              <div>
                <p className="text-sm text-slate-600">Email us at</p>
                <a href="mailto:lexi@onecleangarage.com" className="text-lg font-bold text-slate-900 hover:text-emerald-600">
                  lexi@onecleangarage.com
                </a>
              </div>
            </div>
          </div>

          {/* Return Home Button */}
          <div className="text-center">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors shadow-lg hover:shadow-xl"
            >
              <Home className="h-5 w-5" />
              Return to Home
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ThankYou;
